import {useEffect} from 'react';

import {Pagination, TableSearchInput} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import SettingsCurrencyTable from './SettingsCurrencyTable';
import useCurrencyUpdate from './useCurrencyUpdate';

const CurrencyList = ({
  setCurrencyTotal,
}: {
  setCurrencyTotal: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const {
    isLoading,
    isSearch,
    pageInfo,
    list,
    setPage,
    searchTerm,
    handleSearch,
  } = useCurrencyUpdate();
  useEffect(() => {
    const tots = pageInfo.total ? ` (${pageInfo.total.toLocaleString()})` : '';
    setCurrencyTotal(tots);
  }, [pageInfo, setCurrencyTotal]);

  const loadedContent = list?.length ? (
    <SettingsCurrencyTable list={list} />
  ) : (
    <div className="flex items-center gap-1 justify-center mt-5">
      <p className="text-gray-800">
        {searchTerm.trim()
          ? 'No currencies match your search.'
          : 'No currencies found.'}
      </p>
    </div>
  );

  return (
    <>
      <div className="w-full flex justify-between items-center mb-3 gap-3">
        <TableSearchInput
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search by name or code"
        />
      </div>

      <main className="pt-5 py-10 overflow-x-auto">
        {isLoading ? (
          <div className="min-w-full">
            <TableSkeleton />
          </div>
        ) : (
          loadedContent
        )}
        {list && list.length ? (
          <Pagination
            onPageChange={
              ((params) =>
                setPage(
                  params.page as number,
                )) as PaginationProps['onPageChange']
            }
            total={pageInfo?.total}
            isSearch={isSearch}
          />
        ) : null}
      </main>
    </>
  );
};

export default CurrencyList;
